import styled from 'styled-components';

export const Container = styled.div`
	padding: 20px;
`;

export const MarginMinus20 = styled.div`
	margin: 0 -20px;
`;

export const VerticalPadding20 = styled.div`
	padding: 20px 0;
`;

export const Padding20 = styled.div`
	padding: 10px;
`;

export const PlanDescriptionCont = styled.div`
	margin-top: 175px;
`;
